import type { ReactNode } from 'react'

export const EmptyState = ({ title, description, action }: { title: string; description?: string; action?: ReactNode }) => (
  <div className="empty-state">
    <h2 className="empty-state-title">{title}</h2>
    {description === undefined ? null : <p className="empty-state-body">{description}</p>}
    {action}
  </div>
)
